<template>
  <div class="columns">
    <div class="column is-12" v-if="tiersInformation.urlPortailAnnonceur">
      <div class="card height-100">
        <header class="header-card">
          <p>
            {{ $t('editionClient.generalTitle.portail')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns">
            <div class="column is-narrow pdr-0">
              <qd-switch v-model="tiersInformation.portail" disabled>
              </qd-switch>
            </div>
            <div class="column is-2 pdl-0">
              <span class="has-text-default"> {{ $t(tiersInformation.portail
                ? 'editionClient.portail.activePortail'
                : 'editionClient.portail.desactivePortail') }} </span>
            </div>
            <div class="column is-2" v-if="tiersInformation.portail">
              <a class="lien" :href="tiersInformation.urlPortailAnnonceur" target="_blank">
                {{ $t('editionClient.portail.access') }}
              </a>
            </div>
            <div class="column is-2" v-if="tiersInformation.portail">
              <a class="lien" @click="copyLink()">
                {{ $t('editionClient.portail.copy') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import messageSuccess from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';

export default {
  props: {
    tiersInformation: {
      required: true,
      type: Object,
    },
  },
  methods: {
    copyLink() {
      const domCreate = document.createElement('input');
      document.body.appendChild(domCreate);
      domCreate.setAttribute('value', this.tiersInformation.urlPortailAnnonceur);
      domCreate.select();
      try {
        document.execCommand('copy');
        messageSuccess(this.$i18n.t('general.messages.success.copyLink'));
      } catch (e) {
        messageErreur(this.$i18n);
      }
    },
  },
  mounted() {
    this.setInformationPage(this.$t('pageGeneral.detail', { item: this.tiersInformation.nomCommercial }));
  },
};
</script>
